export enum SupportTicketStatus {
  New,
  WaitingForAffiliate,
  WaitingForAdmin,
  Resolved,
}
